module.exports = __webpack_public_path__ + "static/media/photo2.796626dc.jpg";